import { createStyle } from '@gluestack-style/react';
export const Button = createStyle({
    borderRadius: '$sm',
    backgroundColor: '$primary700',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '$2',
    _text: {
        fontWeight: '$normal',
        _dark: {
            color: '$textDark0',
        },
    },
    _icon: {
        color: '$textLight0',
        _dark: {
            color: '$textDark0',
        },
    },
    _spinner: {
        props: {
            color: '$backgroundLight0',
        },
        _dark: {
            props: {
                color: '$backgroundDark0',
            },
        },
    },
    variants: {
        variant: {
            link: {
                bg: 'transparent',
                px: '$0',
                _text: {
                    props: {
                        color: '$gray800',
                    },
                    textDecorationLine: 'underline',
                },
                ':hover': {
                    _text: {
                        // textDecorationLine: 'underline',
                        textDecorationThickness: '2px',
                    },
                },
                ':active': {
                    _text: {
                        textDecorationLine: 'underline',
                    },
                },
            },
            outline: {
                bg: 'transparent',
                borderWidth: '$1',
                _text: {
                    color: '$primary700',
                },
                _icon: {
                    color: '$primary700',
                },
                borderColor: '$primary700',
                ':hover': {
                    borderColor: '$primary800',
                    _text: {
                        color: '$primary800',
                    },
                    _icon: {
                        color: '$primary800',
                    },
                    bg: 'transparent',
                },
                ':active': {
                    borderColor: '$primary900',
                    color: '$primary900',
                    bg: '$gray100',
                },
                _dark: {
                    bg: 'transparent',
                    ':hover': {
                        bg: '$backgroundDark900',
                    },
                    ':active': {
                        bg: 'transparent',
                    },
                },
            },
            solid: {
                ':hover': {
                    bg: '$primary800',
                },
                ':active': {
                    bg: '$primary900',
                },
                _text: {
                    color: '$textLight0',
                    ':hover': {
                        color: '$textLight0',
                    },
                    ':active': {
                        color: '$textLight0',
                    },
                },
                _spinner: {
                    props: { color: '$textLight0' },
                    ':hover': {
                        props: { color: '$textLight0' },
                    },
                    ':active': {
                        props: { color: '$textLight0' },
                    },
                },
                _icon: {
                    props: { color: '$textLight0' },
                    ':hover': {
                        props: { color: '$textLight0' },
                    },
                    ':active': {
                        props: { color: '$textLight0' },
                    },
                },
                _dark: {
                    _text: {
                        color: '$textDark0',
                        ':hover': {
                            color: '$textDark0',
                        },
                        ':active': {
                            color: '$textDark0',
                        },
                    },
                    _spinner: {
                        props: { color: '$textDark0' },
                        ':hover': {
                            props: { color: '$textDark0' },
                        },
                        ':active': {
                            props: { color: '$textDark0' },
                        },
                    },
                    _icon: {
                        props: { color: '$textDark0' },
                        ':hover': {
                            props: { color: '$textDark0' },
                        },
                        ':active': {
                            props: { color: '$textDark0' },
                        },
                    },
                },
            },
            ghost: {
                bg: 'transparent',
                borderWidth: 0,
                _text: {
                    color: '$primary700',
                },
                _icon: {
                    color: '$primary700',
                },
                borderColor: 'transparent',
                ':hover': {
                    _text: {
                        color: '$primary800',
                    },
                    _icon: {
                        color: '$primary800',
                    },
                    bg: '$primary100',
                },
                ':active': {
                    color: '$primary900',
                    _text: { color: '$primary900' },
                    _icon: { color: '$primary900' },
                    bg: '$gray100',
                },
            },
        },
        size: {
            xs: {
                px: '$3',
                h: '$8',
                _icon: {
                    props: {
                        size: '2xs',
                    },
                },
                _text: {
                    props: {
                        size: 'sm',
                    },
                },
            },
            sm: {
                px: '$3',
                h: '$8',
                _icon: {
                    props: {
                        size: 'sm',
                    },
                },
                _text: {
                    props: {
                        size: 'md',
                    },
                },
            },
            md: {
                px: '$3',
                h: '$10',
                _icon: {
                    props: {
                        size: 'md',
                    },
                },
                _text: {
                    props: {
                        size: 'lg',
                    },
                },
            },
            lg: {
                px: '$3',
                h: '$12',
                _icon: {
                    props: {
                        size: 'md',
                    },
                },
                _text: {
                    props: {
                        size: 'lg',
                    },
                },
            },
            xl: {
                px: '$3',
                h: '$12',
                _icon: {
                    props: {
                        size: 'lg',
                    },
                },
                _text: {
                    props: {
                        size: 'xl',
                    },
                },
            },
        },
    },
    props: {
        size: 'md',
        variant: 'solid',
        action: 'primary',
    },
    _web: {
        minWidth: '$40',
        px: '$3',
        ':focusVisible': {
            outlineWidth: '$0.5',
            outlineColor: '$primary700',
            outlineStyle: 'solid',
            _dark: {
                outlineColor: '$primary300',
            },
        },
    },
    ':disabled': {
        opacity: 0.4,
        backgroundColor: '$gray400',
    },
});
